import { format } from "date-fns";
import { tr } from "date-fns/locale";

/* "₺84.250" — integers, tr-TR grouping (artifact style) */
export const fmt = (n) =>
  "₺" + Math.round(Math.abs(Number(n) || 0)).toLocaleString("tr-TR");

/* "−₺12.500" for negatives */
export const fmtSigned = (n) => {
  const v = Number(n) || 0;
  return (v < 0 ? "−" : "") + fmt(v);
};

/* Turkish month label, capitalized: "Temmuz 2026" */
export const monthLabel = (date) => {
  const s = format(date, "LLLL yyyy", { locale: tr });
  return s.charAt(0).toLocaleUpperCase("tr-TR") + s.slice(1);
};

/* Short month: "Tem" */
export const monthShort = (date) => {
  const s = format(date, "LLL", { locale: tr });
  const clean = s.replace(".", "");
  return clean.charAt(0).toLocaleUpperCase("tr-TR") + clean.slice(1);
};

/* Known transaction category keys → Turkish display labels */
const CATEGORY_LABELS = {
  student_payment: "Üye ödemeleri",
  trainer_salary: "Eğitmen maaşları",
  trainer_payout: "Eğitmen hakedişi",
  rent: "Kira",
  utilities: "Faturalar",
  equipment: "Ekipman & bakım",
  marketing: "Pazarlama",
  supplies: "Sarf malzeme",
  other: "Diğer",
};

export const categoryLabel = (category) => {
  if (!category) return "Diğer";
  const key = String(category).trim();
  return CATEGORY_LABELS[key.toLowerCase()] || key;
};

export const STATUS_LABELS = {
  completed: "Tamamlandı",
  pending: "Beklemede",
  cancelled: "İptal edildi",
};

export const PAYMENT_METHOD_LABELS = {
  cash: "Nakit",
  card: "Kredi kartı",
  credit_card: "Kredi kartı",
  transfer: "Havale",
  bank_transfer: "Havale",
  auto: "Otomatik ödeme",
};

export const paymentMethodLabel = (m) =>
  m ? PAYMENT_METHOD_LABELS[String(m).toLowerCase()] || m : "—";

export const statusLabel = (s) =>
  s ? STATUS_LABELS[String(s).toLowerCase()] || s : "—";

/* Initials for avatars: "Yakup Nayır" → "YN" */
export const initials = (name) =>
  String(name || "?")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toLocaleUpperCase("tr-TR");

/* Sum an array by a numeric field */
export const sumBy = (arr, sel) =>
  (arr || []).reduce((s, x) => s + (Number(sel(x)) || 0), 0);

/* Group transactions by category → sorted rows [{key,label,amount,count}] */
export const groupByCategory = (txs) => {
  const map = new Map();
  (txs || []).forEach((t) => {
    const key = t.category || "other";
    const cur = map.get(key) || { key, amount: 0, count: 0 };
    cur.amount += Number(t.amount) || 0;
    cur.count += 1;
    map.set(key, cur);
  });
  return [...map.values()]
    .map((r) => ({ ...r, label: categoryLabel(r.key) }))
    .sort((a, b) => b.amount - a.amount);
};
